//主app js bridge定位
var isInApp = function () {
    return ~navigator.userAgent.indexOf("dianping");
};


module.exports = function (suc, fail, next) {
    if (!isInApp()) {
        next();
    } else {
        require.ensure([], function (require) {
            var KNB = require("@dp/knb/bundle");
            KNB.ready(function () {
                KNB.getLocation({
                    timeout: 6000,
                    success: function (e) {
                        suc({
                            lat: e.lat,
                            lng: e.lng
                        });
                    },
                    fail: fail
                });
            });
        });
    }
};

module.exports.type = "app";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/app.js